<template>
    <section class="footer">
        <div class="footer-div-wrap">
          <div class="footer-div-1">
            <div class="footer-div1-left">
              <img :sizes="'(max-width: 2083px) 100vw, 2083px'" 
                :srcset="`${assetPath}/_Rx-Pros-Logo-White-01-p-500.png 500w, ${assetPath}/_Rx-Pros-Logo-White-01-p-800.png 800w, ${assetPath}/_Rx-Pros-Logo-White-01-p-1080.png 1080w, ${assetPath}/_Rx-Pros-Logo-White-01-p-1600.png 1600w, ${assetPath}/_Rx-Pros-Logo-White-01.png 2083w`" 
                :alt="appName" :src="`${assetPath}/_Rx-Pros-Logo-White-01.png`" loading="lazy" class="footer-logo">
              <div class="text-block-1220">1309 Coffeen Ave Ste 15880<br>Sheridan, WY 82801</div>
            </div>
            
            <div class="footer-div1-right">
              <!-- Footer navigation -->
              
              <div class="footer-column-div legal">
                <div class="footer-header">Legal</div>
                <div class="footer-text-link" v-for="(item, index) in legalLinks" :key="`legal-${index}`">
                  <a :href="item.link" class="link" target="_blank">{{ item.name }}</a>
                </div>
              </div>
              
              <div class="footer-column-div company">
                <div class="footer-header">Company</div>
                <div class="footer-text-link">
                  <a href="https://rxpros.com/about/" class="link">About</a>
                </div>
              </div>
            </div>
            
            <div class="div-block-1989">
              <div class="code-embed">
                  <a href="https://www.legitscript.com/websites/?checker_keywords=rxpros.com" target="_blank"><img loading="lazy" src="https://static.legitscript.com/seals/37477272.png" alt="" width="75" height="80" class="image-529"></a>
              </div>
            </div>
          </div>
          
          <div class="footer-div-2">
            <div class="text-block-143">© {{ new Date().getFullYear() }} RxPros LLC. All rights reserved.</div>
            <div class="footer-div2-right">
              <img loading="lazy" :src="`${assetPath}/icon_card_visa_1icon_card_visa.png`" alt="" class="image-2">
              <img loading="lazy" :src="`${assetPath}/icon_card_mastercard_1icon_card_mastercard.png`" alt="" class="image-2">
              <img loading="lazy" :src="`${assetPath}/icon_card_amex_1icon_card_amex.png`" alt="" class="image-2">
            </div>
          </div>
        </div>
      </section>
</template>
<script>
export default {
    name: 'footerComponent',
    data() {
        return {
          appMainWeb: process.env.VUE_APP_HOMEPAGE,
          assetPath: '/images', // Path to your assets/images
          appName: "RXPros",
          legalLinks: [
          { name: 'HIPAA Notice', link: `${process.env.VUE_APP_HOMEPAGE}/hipaa` },
          { name: 'Privacy Policy', link: `${process.env.VUE_APP_HOMEPAGE}/privacy` },
          { name: 'Returns & Refund Policy', link: `${process.env.VUE_APP_HOMEPAGE}/returns` },
          { name: 'Terms Of Use', link: `${process.env.VUE_APP_HOMEPAGE}/terms` },
          { name: 'CCPA Opt-Out', link: `${process.env.VUE_APP_HOMEPAGE}/ccpa` },
          { name: 'TeleHealth Consent', link: `${process.env.VUE_APP_HOMEPAGE}/telehealth` },
          { name: 'SMS Terms & Conditions', link: `${process.env.VUE_APP_HOMEPAGE}/sms-terms-conditions` },
          { name: 'Help Center', link: 'https://help.rxpros.com/en/help' }
        ]
        }
    },
    computed: {
        getYear() {
            return new Date().getFullYear();
        },
    },

}
</script>
